import React from 'react'

export default function NotFound() {
  return (
    <h1>Unable to redirect you to the previous page. Please rescan!</h1>
  )
}
